"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./DisplayCreditRow.css");

var _styles = {
  "program": "DisplayCreditRow__program___3eL2E",
  "program-year": "DisplayCreditRow__program-year___xkMSv",
  "program-status": "DisplayCreditRow__program-status___2LvvS",
  "empty-state": "DisplayCreditRow__empty-state___3VRT5"
};

const styles = _bind.default.bind(_styles);

const DisplayCreditRow = (0, _mobxReact.observer)(({
  className,
  programYear,
  programName,
  programStatus = 'active',
  programStatusLabel,
  emptyStateText,
  statusMoreInfo,
  statusMoreInfoOnClick,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('program'), className);
  return _react.default.createElement(_.Content, {
    flex: true,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingTopBottom: 16,
    paddingLeftRight: 24,
    className: composed_classname,
    dataTestId: dataTestId,
    ...props
  }, programStatus === 'empty' || emptyStateText ? _react.default.createElement(_.Text, {
    text: emptyStateText,
    size: 15,
    className: styles('empty-state')
  }) : _react.default.createElement(_react.default.Fragment, null, programYear && _react.default.createElement(_.DateFlag, {
    text: programYear === null || programYear === void 0 ? void 0 : programYear.toString()
  }), _react.default.createElement(_.Text, {
    text: programName,
    className: styles('program-name'),
    size: 15
  }), _react.default.createElement("div", {
    className: styles('program-status', programStatus)
  }, programStatus === 'action-required' && _react.default.createElement(_.Icon, {
    name: _.IconEnum.exclamation_triangle,
    size: 18,
    color: _.Color.semantic.$warning50
  }), _react.default.createElement(_.Text, {
    text: programStatusLabel,
    size: 15,
    status: programStatus === 'action-required' ? 'warning' : 'in_process'
  }), programStatus === 'active' && statusMoreInfoOnClick && statusMoreInfo ? _react.default.createElement(_.Tooltip, {
    text: statusMoreInfo,
    position: 'top'
  }, _react.default.createElement(_.Icon, {
    name: _.IconEnum.question_circle,
    size: 18,
    color: _.Color.blue._60,
    onClick: statusMoreInfoOnClick
  })) : programStatus === 'active' && statusMoreInfo && _react.default.createElement(_.Tooltip, {
    text: statusMoreInfo,
    position: 'top'
  }, _react.default.createElement(_.Icon, {
    name: _.IconEnum.question_circle,
    size: 18,
    color: _.Color.neutral._60
  })))));
});
var _default = DisplayCreditRow;
exports.default = _default;